import { takeEvery, put, call, fork, delay } from 'redux-saga/effects';
import { Client } from '../../utils/client';
import {
    WORKFLOW_SEARCH,
    workflowSearchOnSuccess,
    workflowSearchOnFail,
} from './actions';
import { appLogout } from '../../redux-root/actions';

const WORKFLOW_API_URL = process.env.REACT_APP_WORKFLOW_API_URL

export function* searchFilter(action) {
//   const paramObject = Object.assign({}, action.payload);
  let params = '';

//   if (paramObject.serviceId) {
//     params = `serviceId=${paramObject.serviceId}`;
//   } else {
//     Object.keys(paramObject).forEach(key => {
//       if (params) {
//         params += `&${key}=${paramObject[key]}`;
//       } else {
//         params += `${key}=${paramObject[key]}`;
//       }
//     });
//   }

  try {
    const data = yield call(Client.getData, `${WORKFLOW_API_URL}/api/v1/portal/workflow?${params}`);
    // const data = yield call(Client.getData, `/api/v1/portal/workflow?${params}`);

    yield put(workflowSearchOnSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
        yield put(appLogout(true));
    } else {
        yield put(workflowSearchOnFail(error));
    }
  }
}

function* watchSearchOnFilter() {
  yield takeEvery(WORKFLOW_SEARCH, searchFilter);
}


export function* workflowSaga() {
    yield fork(watchSearchOnFilter);
}